<template>
  <div class="content">
    <div class="container-fluid h-100">
      <div class="container-fluid h-100">
        <div class="row h-100">
          <div class="col h-100">
            <card-item>
              <div class="d-flex justify-content-end">
                <button class="btn btn-danger btn-sm" @click="volver">
                  volver
                </button>
              </div>
            </card-item>
            <card-item
              class="striped-tabled-with-hover"
              body-classes="table-full-width table-responsive"
            >
              <div class="container-fluid">
                <div class="row">
                  <div class="col d-flex justify-content-between">
                    <div>
                      <h4 class="card-title">
                        Vehiculos para revisión técnica
                      </h4>
                      <p class="card-category">Listado</p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container-fluid h-100">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="quickFilter" class="label"
                        >Filtro rapido</label
                      >
                      <input
                        type="text"
                        id="quickFilter"
                        v-model="quickFilter"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div class="row" style="height: 100%">
                  <div class="col" style="position: relative; height: 100%">
                    <ag-grid-vue
                      style="width: 100%; height: 50vh"
                      class="ag-theme-alpine"
                      :columnDefs="columnDefs"
                      :rowData="rowData"
                      @grid-ready="onGridReady"
                      :defaultColDef="defaultColDef"
                      :gridOptions="gridOptions"
                      :getContextMenuItems="getContextMenuItems"
                    >
                    </ag-grid-vue>
                  </div>
                </div>
              </div>
            </card-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { AllModules } from "ag-grid-enterprise";

export default {
  name: "VehiculosParaRevisionTecnica",
  components: { AgGridVue },
  computed: {
    rowData: {
      get() {
        return this.$store.getters["AccesoTesteo/getTesteos"];
      },
    },
  },
  methods: {
    volver() {
      this.$router.push(`/admin/acceso-testeos`);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
  },
  data: () => ({
    // rowData: null,
    quickFilter: "",
    // ag-grid config
    modules: AllModules,
    gridApi: null,
    columnApi: null,

    gridOptions: {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    },

    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
      minWidth: 150,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    },
    columnDefs: [
      {
        headerName: "# Id AVL",
        field: "id_avl",
        sort: "asc",
        comparator: (a, b) => {
          const numA = parseInt(a);
          const numB = parseInt(b);
          return numA - numB;
        },
        maxWidth: 130,
      },
      {
        headerName: "Último Voltaje",
        field: "voltaje_vehiculo",
      },
      {
        headerName: "Últ. Registro AVL",
        field: "hora_avl",
        minWidth: 200,
      },
      {
        headerName: "Últ. Sistema",
        field: "hora_sistema",
        minWidth: 200,
      },
      {
        headerName: "Últ. Sat",
        field: "hora_satelite",
        minWidth: 200,
      },
      {
        headerName: "Patente",
        field: "patente",
      },
      {
        headerName: "Alias",
        field: "dominio",
      },
      {
        headerName: "Marca Modelo",
        field: "Marca Modelo",
      },
      {
        headerName: "Ubicación AVL",
        field: "ubicacion",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Trazabilidad",
        field: "trazabilidad",
        wrapText: true,
        autoHeight: true,
      },
    ],
  }),
  watch: {
    quickFilter(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
};
</script>
<style></style>
